import { Card } from '@eventbrite/eds-card';
import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/marmalade';
import React from 'react';
import './RemoveEventCard.scss';
import { RemoveEventCardProps } from './types';

export const RemoveEventCard: React.FunctionComponent<RemoveEventCardProps> = (
    props,
) => {
    const { onRemoveEvent, onUndoRemoveEvent } = props;
    return (
        <Card style={'neutral'} containerClassName="eds-card__removed-event">
            <div className="eds-card__content">
                <div className="eds-card__removed-event-bottom">
                    <div className="eds-card__removed-event-text">
                        {gettext(
                            'Are you sure you want to remove this event from your recommendations?',
                        )}
                    </div>
                    <div className="eds-card__removed-event__actions">
                        <Button onClick={onRemoveEvent} variant="ghost">
                            {gettext('Yes')}
                        </Button>
                        <Button onClick={onUndoRemoveEvent} variant="ghost">
                            {gettext('Cancel')}
                        </Button>
                    </div>
                </div>
            </div>
        </Card>
    );
};
